export default "__VITE_ASSET__DFBLUdvq__"